export const SaleOrderApiAdapter = {
	actionChangePersonType: 'actionChangePersonType',

	sendRefreshRequest(orderStore) {
		const payload = this._prepareOrderRequest(orderStore);
		return window.checkoutAPI.refresh(payload);
	},

	sendOrderRegisterRequest(orderStore) {
		const payload = this._prepareOrderRequest(orderStore);
		return window.checkoutAPI.saveOrder(payload);
	},

	_normalizeValue(val) {
		return val ? val : '';
	},

	_prepareOrderRequest(orderStore) {
		const payload = {};
		
		if (orderStore.currentPersonType) {
			payload['PERSON_TYPE'] = orderStore.currentPersonType.id;
			payload['PERSON_TYPE_OLD'] = orderStore.currentPersonType.id;
		}
		
		if (orderStore.previousPersonType)
			payload['PERSON_TYPE_OLD'] = orderStore.previousPersonType.id;

		payload['PROFILE_ID'] = orderStore.currentUserProfile?.id || 0;

		if (orderStore.currentUserProfile?.id !== orderStore.previousUserProfile?.id)
			payload['profile_change'] = 'Y';
		else
			payload['profile_change'] = 'N';


		payload['BUYER_STORE'] = orderStore.currentStore?.id || 0;

		if (orderStore.currentDeliverySystem)
			payload['DELIVERY_ID'] = orderStore.currentDeliverySystem.id;

		if (orderStore.currentPaymentSystem) {
			payload['PAY_SYSTEM_ID'] = orderStore.currentPaymentSystem.id;
			payload['PAY_CURRENT_ACCOUNT'] = 'N';
		}

		payload['ORDER_DESCRIPTION'] = orderStore.orderComment || '';


		orderStore.personalFields.forEach(function (field) {
			payload[field.fieldName] = orderStore.fieldsPersistentValues[field.id];
		});

		orderStore.addressFields.forEach(function (field) {
			payload[field.fieldName] = orderStore.fieldsPersistentValues[field.id];
			if (field.isZip === 'Y') {
				const curZipValue = orderStore.fieldsPersistentValues[field.id];

				if (curZipValue && curZipValue !== field.value)
					payload['ZIP_PROPERTY_CHANGED'] = 'Y';
			}
		});

		const locationField = orderStore.addressFieldsMap.location || {};
		payload['location_type'] = 'code';
		payload['location_property_id'] = locationField.id;
		payload['location_value'] = orderStore.fieldsPersistentValues[locationField.id];

		const zipField = orderStore.addressFieldsMap.zip || {};
		payload['zip_property_id'] = zipField.id;
		payload['zip_value'] = orderStore.fieldsPersistentValues[zipField.id];

		const addressField = orderStore.addressFieldsMap.address || {};
		payload['address_property_id'] = addressField.id;
		payload['address_value'] = orderStore.fieldsPersistentValues[addressField.id];

		// TODO: document
		payload['dadata_suggestion_json'] = JSON.stringify(orderStore.addressDadataSuggestion);

		// payload['DELIVERY_EXTRA'] = 'Y';
		// payload['confirmorder'] = 'Y';
		// payload['save'] = 'Y';
		// payload['do_authorize'] = 'Y';
		// payload['do_register'] = 'Y';
		/*
		if(doAuthorize) {
			 payload['USER_LOGIN'] = 'Y';
			 payload['USER_REMEMBER'] = 'Y';
			 payload['USER_PASSWORD'] = 'Y';
		}
		if(doRegister) {
			 payload['NEW_NAME'] = 'Y';
			 payload['NEW_LAST_NAME'] = 'Y';
			 payload['NEW_EMAIL'] = 'Y';
			 payload['PHONE_NUMBER'] = 'Y';
			 payload['NEW_GENERATE'] = 'Y';
			 payload['NEW_LOGIN'] = 'Y';
			 payload['NEW_PASSWORD'] = 'Y';
			 payload['NEW_PASSWORD_CONFIRM'] = 'Y';
			 payload['captcha_word'] = 'Y';
			 payload['captcha_sid'] = 'Y';
		}
		*/

		return payload;
	}
};
